import { Component } from '@angular/core';
import { HuntApiService, ImportResult } from '../hunt-api.service';
import { accessMessage } from '../hunt-errors';

@Component({
  selector: 'app-hunt-import',
  templateUrl: './hunt-import.component.html',
  styleUrls: ['./hunt-import.component.scss'],
})
export class HuntImportComponent {
  fileName = '';
  csv = '';
  force = false;
  startAt: number | null = null;
  preview: ImportResult | null = null;
  saved: ImportResult | null = null;
  busy = false;
  error = '';

  constructor(private api: HuntApiService) {}

  onFile(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';
    if (!file) return;
    if (file.size > 1.5 * 1024 * 1024) { this.error = 'That file is too big (max 1.5 MB).'; return; }
    const reader = new FileReader();
    reader.onload = () => {
      this.fileName = file.name;
      this.csv = String(reader.result || '');
      this.runPreview();
    };
    reader.readAsText(file);
  }

  /** Dry run: shows exactly what would be saved, with nothing written. */
  runPreview() {
    if (!this.csv) return;
    this.busy = true;
    this.error = '';
    this.saved = null;
    this.api.importCsv(this.csv, { dryRun: true, force: this.force, startAt: this.startAt || undefined }).subscribe(
      (r) => { this.preview = r; this.busy = false; },
      (e) => { this.preview = null; this.busy = false; this.error = accessMessage(e); },
    );
  }

  save() {
    if (!this.preview || !this.preview.bones.length) return;
    const skip = this.preview.errors.length ? ` ${this.preview.errors.length} row(s) with errors will be skipped.` : '';
    if (!confirm(`Save ${this.preview.bones.length} bones?${skip}`)) return;
    this.busy = true;
    this.api.importCsv(this.csv, { dryRun: false, force: this.force, startAt: this.startAt || undefined }).subscribe(
      (r) => { this.saved = r; this.preview = null; this.busy = false; },
      (e) => { this.busy = false; this.error = accessMessage(e); },
    );
  }

  clear() {
    this.csv = '';
    this.fileName = '';
    this.preview = null;
    this.saved = null;
    this.error = '';
  }

  downloadTemplate() {
    const csv = [
      'bone,space_id,room,building,locality,city,seats,clue,clue2,clue2_after,reveal',
      '1,-N1O_8bTKDIEh0qj3eBd,6 Seater Meeting Room,AWFIS Prestige Cosmopolitan,Saidapet,Chennai,6,,,,',
      '2,<spaceId>,,,,,,"A boardroom with a view of the lake, Bengaluru.",It\'s at <building>.,30,Bone #2 was in the boardroom at <building>.',
    ].join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
    a.download = 'spark-bones-template.csv';
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  }
}
